import { useState } from 'react';
import type { EntityState } from '../../lib/api.js';
import { useDevices } from '../../context/DevicesContext.js';
import { Toggle } from '../ui/Toggle.js';
import { friendlyName } from '../../lib/utils.js';
import { useToast } from '../ui/Toast.js';

interface Props {
  entityId: string;
  entity: EntityState;
}

export function SwitchCard({ entityId, entity }: Props) {
  const { sendCommand, patchEntity } = useDevices();
  const toast = useToast();
  const isOn = entity.state === 'on';
  const [pending, setPending] = useState(false);

  const handleToggle = async (next: boolean) => {
    const prev = entity;
    patchEntity(entityId, { ...entity, state: next ? 'on' : 'off' });
    setPending(true);
    try {
      await sendCommand('switch', next ? 'turn_on' : 'turn_off', entityId);
    } catch {
      patchEntity(entityId, prev);
      toast.show('Command failed', 'error');
    } finally {
      setPending(false);
    }
  };

  return (
    <div
      className="p-4 rounded-xl border flex items-center justify-between"
      style={{ backgroundColor: 'var(--ac-surface)', borderColor: 'var(--ac-border)' }}
    >
      <div>
        <div className="font-medium text-[var(--ac-text)]">
          {friendlyName(entityId, entity.attributes)}
        </div>
        <div className="text-xs text-[var(--ac-text-muted)]">{isOn ? 'On' : 'Off'}</div>
      </div>
      <Toggle checked={isOn} onChange={handleToggle} disabled={pending} />
    </div>
  );
}
